module.exports = "/static/452981ae1268df6b78b066740f8b04a4.png";